import { axios } from "~/plugins/request";

export const state = () => {
  return {};
};
export const mutations = {};
export const actions = {
  getAgentMemberShipStatistic({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`agentCardManage/getAgentMemberShipStatistic`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getHairpinResume({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`agentCardManage/getHairpinResume`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getSoldRecords({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`agentCardManage/getSoldRecords`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};
